import { useStrings } from "../../localization/localizationHelpers";

// Non-localizable constants (element IDs, not user-facing text)
export const submitModalAriaLabelledById = "submit-ticket-modal-title";
export const detailModalAriaLabelledById = "detail-ticket-modal-title";

const ticketingStringKeys = [
  // ── TicketingPage ──
  "ticketPageTitle",
  "ticketPageSubtitle",
  "ticketTotalLabel",
  "ticketProposedLabel",
  "ticketActiveLabel",
  "ticketResolvedLabel",
  "ticketClosedLabel",
  "ticketSearchPlaceholder",
  "ticketAllTypesLabel",
  "ticketAllSeveritiesLabel",
  "ticketColId",
  "ticketColTitle",
  "ticketColTeam",
  "ticketColType",
  "ticketColSeverity",
  "ticketColStatus",
  "ticketColSubmittedBy",
  "ticketColCreated",
  "ticketColStatusDate",
  "ticketNoTicketsMsg",
  "ticketSubmitRequestLabel",
  "ticketPublisherDropdownLabel",
  "ticketLoadingTicketsLabel",
  "ticketAccessDeniedMsg",
  "ticketSearchAriaLabel",
  "ticketSortAscendingAriaLabel",
  "ticketSortDescendingAriaLabel",
  "ticketFilterByStatusAriaLabel",
  "ticketShowAllAriaLabel",
  "ticketRowAriaLabel",
  "ticketCardCreatedBy",
  "ticketPaginationPrev",
  "ticketPaginationNext",
  "ticketPaginationInfo",
  "ticketPaginationPrevAriaLabel",
  "ticketPaginationNextAriaLabel",

  // ── Filter Panel ──
  "ticketFilterByLabel",
  "ticketFilterSortOrderLabel",
  "ticketFilterNewestFirst",
  "ticketFilterOldestFirst",
  "ticketFilterTitleAsc",
  "ticketFilterTitleDesc",
  "ticketFilterTicketNumberDesc",
  "ticketFilterTicketNumberAsc",
  "ticketFilterDateRangeLabel",
  "ticketFilterCreatedByLabel",
  "ticketFilterCreatedByPlaceholder",
  "ticketFilterTagsLabel",
  "ticketFilterTagsPlaceholder",
  "ticketFilterApplyLabel",
  "ticketFilterResetLabel",
  "ticketFilterButtonAriaLabel",
  "ticketFilterClosePanelAriaLabel",
  "ticketFilterDateFromAriaLabel",
  "ticketFilterDateToAriaLabel",
  "ticketFilterSeverityLabel",
  "ticketFilterTeamLabel",
  "ticketFilterCategoryLabel",
  "ticketFilterSubCategoryLabel",
  "ticketFilterAllCategoriesOption",
  "ticketFilterAllSubCategoriesOption",

  // ── SubmitTicketModal ──
  "ticketSubmitModalTitle",
  "ticketSubmitPageTitle",
  "ticketTitleLabel",
  "ticketDescriptionLabel",
  "ticketTypeLabel",
  "ticketSeverityLabel",
  "ticketCategoryLabel",
  "ticketSubCategoryLabel",
  "ticketTagsLabel",
  "ticketRelatedLinksLabel",
  "ticketSelectType",
  "ticketSelectSeverity",
  "ticketSelectCategory",
  "ticketSelectSubCategory",
  "ticketTeamLabel",
  "ticketTeamPrivateOption",
  "ticketSelectTeam",
  "ticketAllTeamsLabel",
  "ticketTagsPlaceholder",
  "ticketLinkUrlPlaceholder",
  "ticketLinkDescPlaceholder",
  "ticketCancelLabel",
  "ticketSubmitLabel",
  "ticketSubmittingLabel",
  "ticketCloseAriaLabel",
  "ticketRemoveTagAriaLabel",
  "ticketRemoveAttachmentAriaLabel",
  "ticketAddLinkLabel",
  "ticketAddLinkAriaLabel",
  "ticketAddAttachmentAriaLabel",
  "ticketAddTagAriaLabel",
  "ticketTagInputAriaLabel",
  "ticketAttachmentUrlAriaLabel",
  "ticketAttachmentDescAriaLabel",

  // ── TicketDetailModal ──
  "ticketBackToList",
  "ticketDetailStatusLabel",
  "ticketDetailStatusDateLabel",
  "ticketDetailSubmittedByLabel",
  "ticketDetailCreatedLabel",
  "ticketDetailDescriptionLabel",
  "ticketResolutionSummaryLabel",
  "ticketGeneralInfoLabel",
  "ticketNaLabel",
  "ticketCommentsLabel",
  "ticketAddCommentLabel",
  "ticketSendingLabel",
  "ticketCommentPlaceholder",
  "ticketNoCommentsMsg",
  "ticketNoLinksMsg",
  "ticketNoTagsMsg",
  "ticketSaveTagsLabel",
  "ticketSaveLinksLabel",
  "ticketCloseTicketLabel",
  "ticketClosingLabel",
  "ticketRemoveItemAriaLabel",
  "ticketUndoRemoveAriaLabel",
  "ticketLoadingDetailsLabel",
  "ticketSupportAuthor",
  "ticketCustomerAuthor",
  "ticketNumberPrefix",
  "ticketAddLabel",
  "ticketUndoLabel",

  // ── Settings / Notifications ──
  "ticketSettingsAriaLabel",
  "ticketSettingsTitle",
  "ticketSettingsLabel",
  "ticketEmailVerifiedTitle",
  "ticketEmailVerifiedMsg",
  "ticketOkLabel",
  "ticketNotificationEmailLabel",
  "ticketNotificationEmailAriaLabel",
  "ticketSavingLabel",
  "ticketAddingLabel",
  "ticketSaveLabel",
  "ticketVerifiedBadge",
  "ticketNotVerifiedBadge",
  "ticketChangeLabel",
  "ticketInvalidEmailMsg",
  "ticketPromptVerificationTitle",
  "ticketPromptVerificationMsg",
  "ticketPromptGotItLabel",
  "ticketPromptSetEmailTitle",
  "ticketPromptCurrentEmailMsg",
  "ticketPromptDifferentEmailMsg",
  "ticketPromptEmailPlaceholder",
  "ticketPromptNewEmailAriaLabel",
  "ticketPromptKeepCurrentLabel",
  "ticketPromptUseNewLabel",
  "ticketSettingsBackLabel",
  "ticketSettingsPageTitle",
  "ticketSettingsEmailPreferencesTitle",
  "ticketSettingsEmailLabel",
  "ticketSettingsVerificationNotice",
  "ticketSettingsOptOutLabel",
  "ticketTranslationAutoLabel",
  "ticketTranslationHumanLabel",
  "ticketTranslationSeeOriginal",
  "ticketTranslationSeeTranslation",

  // ── Teams Admin ──
  "ticketTeamsAdminTitle",
  "ticketTeamsAdminSubtitle",
  "ticketTeamsAdminCreateButton",
  "ticketTeamsAdminColName",
  "ticketTeamsAdminColMembers",
  "ticketTeamsAdminColManagers",
  "ticketTeamsAdminColStatus",
  "ticketTeamsAdminColCreated",
  "ticketTeamsAdminStatusActive",
  "ticketTeamsAdminStatusInactive",
  "ticketTeamsAdminInactivateAction",
  "ticketTeamsAdminActivateAction",
  "ticketTeamsAdminDefaultBadge",
  "ticketTeamsAdminDefaultInfo",
  "ticketTeamsAdminNoManagers",
  "ticketTeamsAdminLoading",

  // ── Create Team Modal ──
  "ticketCreateTeamModalTitle",
  "ticketCreateTeamNameLabel",
  "ticketCreateTeamNameHint",
  "ticketCreateTeamMembersLabel",
  "ticketCreateTeamMembersHint",
  "ticketCreateTeamSearchPlaceholder",
  "ticketCreateTeamCancelButton",
  "ticketCreateTeamSubmitButton",
  "ticketCreateTeamCreatingButton",
  "ticketCreateTeamNameRequired",
  "ticketCreateTeamNameTooLong",

  // ── Team Detail Page ──
  "ticketTeamDetailBackToSettings",
  "ticketTeamDetailAddMembers",
  "ticketTeamDetailRename",
  "ticketTeamDetailMembersTitle",
  "ticketTeamDetailColName",
  "ticketTeamDetailColEmail",
  "ticketTeamDetailColRole",
  "ticketTeamDetailColAdded",
  "ticketTeamDetailRemove",
  "ticketTeamDetailVisibilityRule",
  "ticketTeamDetailVisibilityDesc",
  "ticketTeamDetailCreatedOn",
  "ticketTeamDetailNoMembers",
  "ticketTeamDetailRenameTitle",
  "ticketTeamDetailRenameLabel",
  "ticketTeamDetailRenameSave",
  "ticketTeamDetailRenameCancel",
  "ticketTeamDetailAddTitle",
  "ticketTeamDetailAddHint",
  "ticketTeamDetailAddButton",
  "ticketTeamDetailAddCancel",
  "ticketTeamDetailSearchPlaceholder",
  "ticketTeamDetailSelectAll",
  "ticketTeamDetailNoMatchPrefix",
  "ticketTeamDetailNoMatchHint",
  "ticketTeamDetailNoMatchSendInvite",
  "ticketTeamDetailLoading",
  "ticketTeamDetailMoreActions",
  "ticketTeamDetailInactivate",
  "ticketTeamDetailActivate",
  "ticketTeamDetailColStatus",
  "ticketTeamDetailMakeManager",
  "ticketTeamDetailRemoveManager",
  "ticketTeamDetailInactiveBanner",
  "ticketTeamDetailInactiveBannerActivate",
  "ticketTeamDetailInvitationsTitle",
  "ticketTeamDetailSendInvite",
  "ticketTeamDetailInviteModalTitle",
  "ticketTeamDetailInviteInfoMessage",
  "ticketTeamDetailInviteUsernameLabel",
  "ticketTeamDetailInviteUsernameHint",
  "ticketTeamDetailInviteUsernameRequired",
  "ticketTeamDetailInviteEmailLabel",
  "ticketTeamDetailInviteEmailHint",
  "ticketTeamDetailInviteCancel",
  "ticketTeamDetailInviteSubmit",
  "ticketTeamDetailInviteNoInvitations",
  "ticketTeamDetailInviteExampleFormats",
  "ticketTeamDetailInviteColLoginEmail",
  "ticketTeamDetailInviteColNotificationEmail",
  "ticketTeamDetailInviteColStatus",
  "ticketTeamDetailInviteColSent",
  "ticketTeamDetailInviteColExpires",
  "ticketTeamDetailInviteUsernamePlaceholder",
  "ticketTeamDetailInviteEmailPlaceholder",
  "ticketTeamDetailInviteRemove",
  "ticketTeamDetailInviteRenew",
  // ── Team Scope (Ticket Detail) ──
  "ticketTeamScopeTitle",
  "ticketTeamScopeCurrentLabel",
  "ticketTeamScopeChangeLabel",
  "ticketTeamScopeSaveButton",
  "ticketTeamScopeSavingButton",
  "ticketTeamScopeHelp",
] as const;

type TicketingStringKey = (typeof ticketingStringKeys)[number];
export type TicketingStrings = Record<TicketingStringKey, string>;

export const useTicketingStrings = (): TicketingStrings => {
  const values = useStrings(...ticketingStringKeys);
  const result = {} as Record<string, string>;
  ticketingStringKeys.forEach((key, i) => {
    result[key] = values[i];
  });
  return result as TicketingStrings;
};
